import { Grid, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

export const NavTabs = styled(Grid)(({ theme }) => ({
  flexDirection: 'row',

  '& .MuiTab-root': {
    color: theme.palette.common.black,

    '&:hover': {
      borderBottomColor: theme.palette.common.black,
    },

    '&.active': {
      color: theme.palette.primary.dark,
    },
  },
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.background.paper,
  },
}));

export const VerticalNavTabs = styled(Grid)(({ theme }) => ({
  flexDirection: 'column',

  '& .MuiTabs-root': {
    boxShadow: 'none',
  },
  '& .MuiTabs-vertical .MuiTab-root': {
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(2),
  },
}));

export const TabsStyled = styled(Tabs)(() => ({
  boxShadow: 'none',
}));
